<template>
  <div class="p-2 px-4">
    <div class="row border">
      <div class="col-2 d-flex justify-content-center align-items-center p-1">
        <div>
          <h3 class="text-center">{{ metricType }}</h3>
          <img :src="require(`../../../assets/${image}`)" />
        </div>
      </div>

      <div class="col-8 border-left border-right d-flex p-2">
        <div class="p-4">
          <h4 class="pt-2">{{ title }}</h4>
          <p>{{ text }}</p>
        </div>
      </div>

      <div class="col-2 d-flex justify-content-center align-items-center">
        <button
          v-if="this.btnDisabled === true"
          class="btn btn-primary btn-lg btn-metric buttonText"
          v-b-modal="`new-action-${metricType}`"
        >
          <span>{{ $t('newAction.selectMetric.button.selectLabel') }}</span>
        </button>
        <button
          v-if="this.btnDisabled === false"
          class="btn btn-secondary text-white btn-lg btn-metric buttonText"
          disabled
        >
          {{ $t('newAction.selectMetric.button.soonLabel') }}
        </button>
      </div>
    </div>

    <b-modal
      :id="`new-action-${metricType}`"
      :title="this.$t('newAction.modalTitle')"
      :cancel-title="this.$t('newAction.stepOne.cancelButton')"
      :ok-title="this.$t('newAction.createAction')"
      size="lg"
      @show="showModal"
      @ok="createAction"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="idx-bold">
              {{ $t('newAction.stepOne.labels.actionName') }}
            </label>

            <input
              id="action-name-id"
              type="text"
              v-model="name"
              class="form-control"
              :placeholder="this.$t('newAction.stepOne.actionName')"
              maxlength="35"
            />

            <div class="invalid-feedback">
              {{ errorMsg }}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <label class="idx-bold">
            {{ $t('newAction.stepOne.labels.methodology') }}
          </label>
          <select class="custom-select" v-model="metric">
            <option
              v-for="(item, i) in metricOptions"
              :value="item.value"
              :key="i"
            >
              {{ item.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-form-group>
            <label class="idx-bold">{{
              $t('newAction.stepOne.labels.collectionCanal')
            }}</label>
            <b-form-radio-group
              name="radio-sub-component"
              :value="channel"
              v-model="channel"
            >
              <b-form-radio name="email-radio" value="email"
                >E-mail</b-form-radio
              >
              <b-form-radio v-if="company.channelWhatsApp" name="email-wpp-radio" value="email/whatsapp"
                >E-mail/Whatsapp</b-form-radio
              >
              <b-form-radio name="sms-radio" value="sms">SMS</b-form-radio>
              <b-form-radio name="emailsms-radio" value="emailsms"
                >Email/SMS</b-form-radio
              >
              <b-form-radio name="widget-radio" value="widget"
                >Widget</b-form-radio
              >
              <b-form-radio name="qrcode-radio" value="qrcode"
                >QrCode</b-form-radio
              >
              <b-form-radio name="link-radio" value="link">Link</b-form-radio>
              <template v-if="company.channelTotem">
                <b-form-radio name="totem-radio" value="totem"
                  >Totem</b-form-radio
                >
              </template>
              <template v-if="company.channelCallCenter"
                ><b-form-radio name="click-to-call" value="click-to-call"
                  >Click-to-call</b-form-radio
                ></template
              >
              <template v-if="company.channelWhatsApp">
              <b-form-radio name="whatsapp" value="whatsapp"
                >Whatsapp</b-form-radio
              >
              </template>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import api from '../../../services/api';

export default {
  name: 'SelectMetric',

  props: {
    metricType: String,
    title: String,
    text: String,
    image: String,
    btnDisabled: Boolean,
  },

  data: () => ({
    metric: null,
    name: null,
    question: null,
    channel: 'email',
    userAuth: null,
    metricOptions: [],
    errorMsg: null,
  }),

  computed: {
    ...mapFields('actions', ['nowStep', 'action']),

    ...mapState('companies', ['company']),

    inputActionName() {
      return document.getElementById('action-name-id');
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  watch: {
    name: function watchActionName(value) {
      if (value.length >= 35) {
        this.errorMsg = this.$t('newAction.stepOne.actionNameSize');
        this.inputActionName.classList.add('is-invalid');
      } else if (value === '') {
        this.errorMsg = this.$t('newAction.stepOne.actionInvalid');
        this.inputActionName.classList.add('is-invalid');
      } else {
        this.inputActionName.classList.remove('is-invalid');
      }
    },
  },

  methods: {
    async createAction(event) {
      if (!this.validateFields()) {
        event.preventDefault();
        return;
      }

      this.setQuestion();

      const actionCreated = await api.post(
        '/action',
        {
          name: this.name,
          type: this.metric,
          channel: this.channel,
          question: this.question,
          email: {
            subject: null,
            from: null,
            template: {
              id: '1',
              myHTML:
                this.channel === 'widget'
                  ? '<p><strong>Olá!</strong></p>'
                  : this.$t('newAction.templateHTML'),
              scale: 'colors',
              brand: null,
              footer: true,
            },
          },
          sms: {
            config: 'link',
            msgLink: this.$t('newAction.answerSurvey'),
            // submits: 0,
          },
          reply: {
            detractors: this.$t('newAction.stepOne.detractors'), // alterar
            neutral: this.$t('newAction.stepOne.neutral'), // alterar
            promoters: this.$t('newAction.stepOne.promoters'), // alterar
            // details
          },
          alertRules: {
            title: `${this.name} - Tratativa Aguardando Retorno`,
          },
          // details
          // uploadedImage: null,
        },
        {
          headers: {
            'x-access-token': this.userAuth.token,
          },
        },
      );

      this.$router.push(`/action/layout/${actionCreated.data._id}`);
    },

    setQuestion() {
      if (this.metric === 'nps-0-10' || !this.metric) {
        this.question = this.$t('newAction.stepOne.scale0a10', {
          companyName: `${this.company.name}`,
        });
      } else if (this.metric === 'nps-1-5') {
        this.question = this.$t('newAction.stepOne.scale1a5', {
          companyName: `${this.company.name}`,
        });
      } else if (this.metric === 'ces-1-5') {
        this.question = this.$t('newAction.stepOne.scaleCES1a5');
      } else if (
        this.metric === 'csat-1-5' ||
        this.metric === 'csat-1-5(media)'
      ) {
        this.question = this.$t('newAction.stepOne.scaleCSAT1to5');
      } else if(this.metric === 'csat-0-10(media)'){
        this.question = this.$t('newAction.stepOne.scaleCSAT0to10');
      } else if (this.metric === '5-stars') {
        this.question = this.$t('newAction.stepOne.question5Stars');
      } else if (this.metric === 'like-dislike') {
        this.question = this.$t('newAction.stepOne.questionLikeDislike');
      }
    },

    showModal() {
      if (this.metricType === 'NPS') {
        this.metric = 'nps-0-10';
        this.metricOptions = [
          {
            value: 'nps-0-10',
            text: this.$t('newAction.stepOne.scaleNps0a10'),
          },
          { value: 'nps-1-5', text: this.$t('newAction.stepOne.scaleNps1a5') },
        ];
      } else if (this.metricType === 'CES') {
        this.metric = 'ces-1-5';
        this.metricOptions = [
          {
            value: 'ces-1-5',
            text: this.$t('newAction.stepOne.labels.cesScale'),
          },
        ];
      } else if (this.metricType === 'CSAT') {
        this.metric = 'csat-1-5';
        this.metricOptions = [
          {
            value: 'csat-1-5',
            text: this.$t('newAction.stepOne.labels.csatScale'),
          },
          {
            value: 'csat-1-5(media)',
            text: this.$t('newAction.stepOne.labels.csatScaleAverage'),
          },
          {
            value: 'csat-0-10(media)',
            text: this.$t('newAction.stepOne.labels.csatScaleAverage0to10'),
          },
        ];
      } else if (this.metricType === 'Reviews') {
        this.metric = '5-stars';
        this.metricOptions = [
          {
            value: '5-stars',
            text: '5-Stars',
          },
        ];
      } else if (this.metricType === 'Like/Dislike') {
        this.metric = 'like-dislike';
        this.metricOptions = [
          {
            value: 'like-dislike',
            text: 'Like/Dislike - 0 e 1',
          },
        ];
      }
    },

    validateFields() {
      if (!this.name) {
        this.errorMsg = this.$t('newAction.stepOne.actionInvalid');
        this.inputActionName.classList.add('is-invalid');
        return false;
      }

      return true;
    },
  },
};
</script>

<style scoped>
img {
  width: 100%;
}

.btn-metric {
  padding-left: 25%;
  padding-right: 25%;
}

.buttonText {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/metric-types/index.vue